var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReviewsStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98156 1.59736L11.6059 4.81861C11.7651 5.13484 12.0724 5.35412 12.4288 5.40487L16.0625 5.92407C16.9603 6.05274 17.3176 7.13283 16.6678 7.75171L14.0402 10.258C13.7819 10.5045 13.6644 10.8588 13.7255 11.2067L14.3456 14.7451C14.4983 15.6204 13.5598 16.2883 12.7573 15.8742L9.50952 14.2024C9.19113 14.0384 8.8098 14.0384 8.49048 14.2024L5.24267 15.8742C4.44021 16.2883 3.50168 15.6204 3.65533 14.7451L4.27453 11.2067C4.33562 10.8588 4.21807 10.5045 3.95984 10.258L1.33216 7.75171C0.682414 7.13283 1.03968 6.05274 1.93748 5.92407L5.57125 5.40487C5.92759 5.35412 6.2358 5.13484 6.395 4.81861L8.01844 1.59736C8.42013 0.800881 9.57987 0.800881 9.98156 1.59736Z",
    stroke: "#737FA4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReviewsStar);
export default __webpack_public_path__ + "static/media/icon-reviews-star.c62fb0be.svg";
export { ForwardRef as ReactComponent };